export default __webpack_public_path__ + "static/dla-poczatkujacych-klocek-14751808c30416894dac75ba384d27ad.svg";